import React from "react";
import PropTypes from "prop-types";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

const ButtonListItem = ({ subItem, title, icon, onClickHandler }) => {
  return (
    <ListItem disablePadding key={title}>
      <ListItemButton
        onClick={onClickHandler || undefined}
        sx={theme => (subItem ? { pl: theme.spacing(4) } : undefined)}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
};

ButtonListItem.defaultProps = {
  onClickHandler: null,
  subItem: false,
};

ButtonListItem.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  subItem: PropTypes.bool,
  onClickHandler: PropTypes.func,
};

export default ButtonListItem;
